import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {NotificationsService} from "../../../services/notifications.service";
import {HttpService} from "../../../../../services/http.service";
import {AuthService} from "../../../../../services/auth.service";
import {JalaliPipe} from "../../../pipes/jalali.pipe";
import {ActivatedRoute} from "@angular/router";
import {VendorTaxClearanceService} from "../vendor-tax-clearance.service";

@Component({
    selector: 'app-view-dialog',
    templateUrl: './view-dialog.component.html',
    styleUrls: ['./view-dialog.component.styl']
})
export class ViewDialogComponent implements OnInit {

    data;


    constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
                public notificationsService: NotificationsService,
                private httpService: HttpService,
                private auth: AuthService,
                private jalaliPipe: JalaliPipe,
                public activatedRoute: ActivatedRoute,
                public vendorTaxClearanceService: VendorTaxClearanceService) {
    }

    ngOnInit() {
        this.notificationsService.startLoading();

        this.vendorTaxClearanceService.show(this.dialogData.id, !('year' in this.dialogData) ? 1 : 0).subscribe((data) => {
            this.data = data;
            this.notificationsService.dismissLoading();
        });
    }


    print(form: HTMLElement) {
        this.httpService.get('api/get-current-datetime').subscribe(currentDatetime => {
            const frame1 = document.createElement('iframe');
            frame1.name = 'frame';
            frame1.style.display = 'none';
            document.body.appendChild(frame1);
            const frameDoc = frame1.contentWindow;
            frameDoc.document.open();
            frameDoc.document.write('');
            frameDoc.document.write(`
                    <html>
                        <head>
                            <style>
                                html, * {
                                    direction: rtl !important;
                                }
                                table,
                                th,
                                td {
                                  direction: ltr;
                                  border: 1px solid #000 !important;
                                  border-collapse: collapse !important;
                                }
                                table {
                                  width: 100%;
                                  font-size: 12px;
                                }
                                table .row {
                                  direction: ltr;
                                  display: flex;
                                  border: none;
                                  justify-content: space-around;
                                }
                                table .row .column {
                                  direction: ltr;
                                  display: flex;
                                  flex-direction: column;
                                  justify-content: center;
                                  text-align: center;
                                  align-items: center;
                                  width: 100%;
                                  margin-top: 0;
                                  margin-bottom: 0;
                                }
                                table .row .logo{
                                    font-size: 11px;
                                    width: 120%;
                                }
                                table .row .column img {
                                  width: 60px;
                                  margin-bottom: 5px;
                                }
                                table .row .column span {
                                  display: block;
                                }
                                table .center-text {
                                  text-align: center;
                                }
                                table .header {
                                  font-size: 20px;
                                  margin: 10px;
                                }
                                table .address {
                                  padding: 0 25px;
                                }
                                table .address .location {
                                  display: flex;
                                }
                                table .address .location p {
                                  margin: 3px;
                                  width: 47%;
                                }
                                table .address .location p span {
                                  display: block;
                                }
                                table .address .location p span .right-space{
                                display: inline-block;
                                margin-right: 15px;
                                }
                                table .address .name {
                                  font-size: 14px;
                                  direction: rtl;
                                }
                                .message{
                                    position: absolute;
                                    bottom: 10px;
                                    right: 10px;
                                    direction: ltr;
                                    text-align: right;
                                    font-size: 12px;
                                }
                            </style>
                        </head>
                        <body onload="window.print();window.close()">
                        <div class="message">نوت: معلومات مندرجه سند هذا از سیستم مالیه دهندگان (SIGTAS (Standard Integrated Government Tax Administration System طبق تفاهمنامه مؤرخ 1398-05-10 به صورت خودکار ذریعه API  گرفته شده و به تاریخ ${this.jalaliPipe.transform(currentDatetime.date)} و ساعت ${currentDatetime.time} به وقت کابل با شماره تشخیصیه کاربری (${this.auth.loggedInUser.username}) کاربر سیستم تدارکات الکترونیکی و باز افغانستان دانلود گردیده است. </div>
`);
            frameDoc.document.write(form.innerHTML);
            frameDoc.document.write('</body></html>');
            frameDoc.document.close();
        });
    }


}
